import React, { FC, HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'clsx';

import { FOOTER_TEST_IDS } from './const';
import { isColorLight } from 'utils/Color';

import styles from './styles.module.scss';

type FooterProps = HTMLProps<HTMLElement> & {
  customFooterColor?: string;
  customFooterText?: string;
  isInvoiceMode?: boolean;
}

export const Footer: FC<FooterProps> = ({ customFooterColor, customFooterText, isInvoiceMode = true, className, children, ...props }) => {
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  const { root, copyright, other, trademark, terms, privacy, footerText } = FOOTER_TEST_IDS;

  return (
    <footer
      className={cx(styles.footer, className)}
      data-testid={root}
      {...(!isInvoiceMode && { style: { backgroundColor: customFooterColor } })}
      {...props}
    >
      <div className={cx(styles.container, {
        [styles.containerDark]: !isInvoiceMode && customFooterColor && isColorLight(customFooterColor)
      })}>
        {children}
        <section className={cx(styles.section, styles.appLegal)}>
          {!isInvoiceMode && customFooterText
            ? <p data-testid={footerText}>{customFooterText}</p>
            : <>
                <ul className={styles.links}>
                  <li data-testid={copyright}>{t('legal.copyright', { year })}</li>
                  <li data-testid={terms}><a href="/consumer/terms">{t('legal.terms')}</a></li>
                  <li data-testid={privacy}><a href="/privacy-policy">{t('legal.privacy')}</a></li>
                </ul>
                <p data-testid={trademark}>{t('legal.trademark')}</p>
                <p data-testid={other}>{t('legal.other')}</p>
              </>
          }
        </section>
      </div>
    </footer>
  );
};
